<template>
  <div>
    <a-button
      type="primary"
      icon="plus"
      @click="showModal('new')"
      style="margin-bottom: 20px"
      >{{ $t("action.ajouter") }}</a-button
    >
    <!--add activity modal -->
    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      :title="$t('all.enterInformationBelow')"
      :width="800"
      :height="1200"
      :footer="false"
    >
      <a-form :form="form" class="container" @submit="addActivity">
        <!-- Activity Type Selection -->
        <div class="row">
          <div class="col-lg-12">
            <a-form-item :label="$t('etablissement.typeActivite')">
              <a-radio-group
                v-model="activityType"
                @change="handleActivityTypeChange"
              >
                <a-radio value="daily">{{
                  $t("etablissement.parJour")
                }}</a-radio>
                <a-radio value="monthly">{{
                  $t("etablissement.mensuelleParTranche")
                }}</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.nameActivite')">
              <a-input
                :placeholder="$t('etablissement.nameActivite')"
                v-decorator="[
                  'designation',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.nameActivite'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.ordrePriorite')">
              <a-input
                :placeholder="$t('etablissement.ordrePriorite')"
                v-decorator="[
                  'order',
                  {
                    rules: [
                      {
                        required: false,
                        message: $t('requis.order'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.service')">
              <a-select
                show-search
                :autoFocus="true"
                option-filter-prop="children"
                :filter-option="filterOption"
                :placeholder="$t('etablissement.service')"
                v-decorator="[
                  'service',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('requis.service'),
                      },
                    ],
                  },
                ]"
              >
                <a-select-option
                  :value="item._id"
                  v-for="item in activeServicesData"
                  :key="item._id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.responsable')">
              <a-input
                :placeholder="$t('etablissement.responsableActivite')"
                v-decorator="['reponsible']"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('scolarite.fromSchoolYear')">
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                :placeholder="$t('scolarite.fromSchoolYear')"
                v-decorator="[
                  'schoolarYear',
                  {
                    initialValue: settings.activeSchoolarYear,
                    rules: [
                      {
                        required: true,
                        message: $t('requis.schoolarYear'),
                      },
                    ],
                  },
                ]"
              >
                <a-select-option
                  :value="year._id"
                  v-for="year in settings.schoolarYears"
                  :key="year._id"
                  >{{ year.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.dateDebut')">
              <a-date-picker
                style="width: 100%"
                format="DD/MM/YYYY"
                v-decorator="[
                  'start',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('all.requiredStartDate'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.dateFin')">
              <a-date-picker
                :disabled="once"
                style="width: 100%"
                format="DD/MM/YYYY"
                v-decorator="[
                  'end',
                  {
                    rules: [
                      {
                        required: false,
                      },
                      {
                        validator: (rule, value, callback) =>
                          endDateValidator('form', rule, value, callback),
                        message: $t('error.dateFinPlusGrande'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.fraisInscri')">
              <a-input
                type="number"
                step="0.5"
                :placeholder="$t('etablissement.fraisInscri')"
                v-decorator="[
                  `inscription`,
                  {
                    rules: [
                      {
                        required: false,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-2" v-if="activityType === 'monthly'">
            <a-form-item :label="$t('etablissement.seuleFois')">
              <a-switch
                :checked="once"
                @change="trigerOnce"
                v-decorator="[`once`]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-4">
            <a-form-item
              :label="
                activityType === 'daily'
                  ? $t('etablissement.fraisParJour')
                  : $t('etablissement.fraisMensuel')
              "
            >
              <a-input
                type="number"
                step="0.5"
                :disabled="once"
                :placeholder="
                  activityType === 'daily'
                    ? $t('etablissement.fraisParJour')
                    : $t('etablissement.fraisMensuel')
                "
                v-decorator="[
                  `monthly`,
                  {
                    rules: [
                      {
                        required: !once,
                        message:
                          activityType === 'daily'
                            ? $t('requis.fraisParJour')
                            : $t('requis.fraisMensuel'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="row" v-if="activityType === 'monthly'">
          <div class="col-lg-12">
            <a-divider>{{ $t("liste.fraisTranches") }}</a-divider>
            <a-form-item>
              <a-row v-for="(item, index) in tranchesList" :key="index">
                <a-col :span="3">
                  {{ $t("etablissement.tranche") }} {{ item.trancheNumber }} :
                </a-col>
                <a-col :span="11">
                  <a-select
                    v-model="item.months"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('profil.mois')"
                  >
                    <a-select-option
                      v-for="i in monthRangesList"
                      :key="i"
                      :value="i"
                    >
                      {{ moment(i).format("MMMM") }}
                    </a-select-option>
                  </a-select></a-col
                >
                <a-col :span="8">
                  <a-input-number
                    style="width: 100%"
                    class="ml-2"
                    :min="0"
                    :value="item.amount"
                    v-model="item.amount"
                    :placeholder="$t('paymentStatus.montant')"
                /></a-col>
                <a-col :span="2">
                  <a-button
                    type="dashed"
                    class="ml-4"
                    shape="circle"
                    icon="delete"
                    @click="
                      () => {
                        tranchesList.splice(index, 1);
                      }
                    "
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="8"></a-col>
                <a-col :span="14">
                  <a-button
                    type="primary"
                    class="mr-3 m-auto"
                    @click="
                      () => {
                        tranchesList.push({
                          trancheNumber: tranchesList.length + 1,
                          amount: undefined,
                          months: [],
                        });
                      }
                    "
                  >
                    {{ $t("etablissement.addTranche") }}
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </div>
        </div>

        <div class="form-actions mt-0">
          <a-button
            style="width: 150px"
            type="primary"
            htmlType="submit"
            :loading="loadingActivity"
            :disabled="loadingActivity"
            class="mr-3"
            >{{ $t("action.ajouter") }}</a-button
          >
          <a-button
            key="back"
            @click="handleCancel"
            :disabled="loadingActivity"
            >{{ $t("action.annuler") }}</a-button
          >
        </div>
      </a-form>
    </a-modal>
    <!--edit activity modal -->
    <a-drawer
      :title="$t('all.enterInformationBelow')"
      :width="720"
      :visible="visibleEditModal"
      @close="handleCancel()"
    >
      <a-form :form="updateForm" class="container" @submit="save">
        <!-- Activity Type Selection -->
        <div class="row">
          <div class="col-lg-12">
            <a-form-item :label="$t('etablissement.typeActivite')">
              <a-radio-group v-model="editActivityType" :disabled="true">
                <a-radio value="daily">{{
                  $t("etablissement.parJour")
                }}</a-radio>
                <a-radio value="monthly">{{
                  $t("etablissement.mensuelleParTranche")
                }}</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.designation')">
              <a-input
                :placeholder="$t('etablissement.designation')"
                v-decorator="[
                  'designation',
                  {
                    initialValue: selectedActivity.designation,
                    rules: [
                      {
                        required: true,
                        message: $t('requis.designation'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.ordrePriorite')">
              <a-input
                :placeholder="$t('etablissement.ordrePriorite')"
                v-decorator="[
                  'order',
                  {
                    initialValue: selectedActivity.order,

                    rules: [
                      {
                        required: false,
                        message: $t('requis.order'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.service')">
              <a-select
                show-search
                :autoFocus="true"
                option-filter-prop="children"
                :filter-option="filterOption"
                :placeholder="$t('etablissement.service')"
                v-decorator="[
                  'service',
                  {
                    initialValue: selectedActivity.service,
                    rules: [
                      {
                        required: true,
                        message: $t('requis.service'),
                      },
                    ],
                  },
                ]"
              >
                <a-select-option
                  :value="item._id"
                  v-for="item in activeServicesData"
                  :key="item._id"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.responsable')">
              <a-input
                :placeholder="$t('etablissement.responsableActivite')"
                v-decorator="[
                  'reponsible',
                  {
                    initialValue: selectedActivity.reponsible,
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('scolarite.fromSchoolYear')">
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                :placeholder="$t('scolarite.fromSchoolYear')"
                v-decorator="[
                  'schoolarYear',
                  {
                    initialValue:
                      selectedActivity.schoolarYear ||
                      settings.activeSchoolarYear,
                    rules: [
                      {
                        required: true,
                        message: $t('requis.schoolarYear'),
                      },
                    ],
                  },
                ]"
              >
                <a-select-option
                  :value="year._id"
                  v-for="year in settings.schoolarYears"
                  :key="year._id"
                  >{{ year.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.dateDebut')">
              <a-date-picker
                style="width: 100%"
                format="DD/MM/YYYY"
                v-decorator="[
                  'start',
                  {
                    initialValue: selectedActivity.start,
                    rules: [
                      {
                        required: true,
                        message: $t('all.requiredStartDate'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.dateFin')">
              <a-date-picker
                :disabled="selectedActivity.once"
                format="DD/MM/YYYY"
                style="width: 100%"
                v-decorator="[
                  'end',
                  {
                    initialValue: selectedActivity.end,
                    rules: [
                      {
                        required: false,
                      },
                      {
                        validator: (rule, value, callback) =>
                          endDateValidator('updateForm', rule, value, callback),
                        message: $t('error.dateFinPlusGrande'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <a-form-item :label="$t('etablissement.fraisInscri')">
              <a-input
                type="number"
                step="0.5"
                :placeholder="$t('etablissement.fraisInscri')"
                v-decorator="[
                  `inscription`,
                  {
                    initialValue: selectedActivity.inscription,

                    rules: [
                      {
                        required: false,
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-2" v-if="editActivityType === 'monthly'">
            <a-form-item :label="$t('etablissement.seuleFois')">
              <a-switch
                :checked="selectedActivity.once"
                @change="(v) => (selectedActivity.once = v)"
                v-decorator="[`once`]"
              />
            </a-form-item>
          </div>
          <div class="col-lg-4">
            <a-form-item
              :label="
                editActivityType === 'daily'
                  ? $t('etablissement.fraisParJour')
                  : $t('etablissement.fraisMensuel')
              "
            >
              <a-input
                type="number"
                step="0.5"
                :disabled="selectedActivity.once"
                :placeholder="
                  editActivityType === 'daily'
                    ? $t('etablissement.fraisParJour')
                    : $t('etablissement.fraisMensuel')
                "
                v-decorator="[
                  `monthly`,
                  {
                    initialValue: selectedActivity.monthly,

                    rules: [
                      {
                        required: !selectedActivity.once,
                        message:
                          editActivityType === 'daily'
                            ? $t('requis.fraisParJour')
                            : $t('requis.fraisMensuel'),
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="row" v-if="editActivityType === 'monthly'">
          <div class="col-lg-12">
            <a-divider>{{ $t("liste.fraisTranches") }}</a-divider>
            <a-form-item>
              <a-row v-for="(item, index) in selectedTranches" :key="index">
                <a-col :span="3">
                  {{ $t("etablissement.tranche") }} {{ item.trancheNumber }} :
                </a-col>
                <a-col :span="11">
                  <a-select
                    v-model="item.months"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('profil.mois')"
                  >
                    <a-select-option
                      v-for="i in monthRangesList"
                      :key="i"
                      :value="i"
                    >
                      {{ moment(i).format("MMMM") }}
                    </a-select-option>
                  </a-select></a-col
                >
                <a-col :span="8">
                  <a-input-number
                    type="number"
                    style="width: 100%"
                    class="ml-2"
                    :min="0"
                    :value="item.amount"
                    v-model="item.amount"
                    :placeholder="$t('paymentStatus.montant')"
                /></a-col>
                <a-col :span="2">
                  <a-button
                    type="dashed"
                    class="ml-4"
                    shape="circle"
                    icon="delete"
                    @click="
                      () => {
                        selectedTranches.splice(index, 1);
                      }
                    "
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="8"></a-col>
                <a-col :span="14">
                  <a-button
                    type="primary"
                    class="mr-3 m-auto"
                    @click="addTranche"
                  >
                    {{ $t("etablissement.addTranche") }}
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </div>
        </div>
        <div class="form-actions mt-0">
          <a-button
            style="width: 150px"
            type="primary"
            htmlType="submit"
            :loading="loadingActivity"
            :disabled="loadingActivity"
            class="mr-3"
          >
            {{ $t("action.modifier") }}
          </a-button>
          <a-button
            key="back"
            @click="handleCancel"
            :disabled="loadingActivity"
            >{{ $t("action.annuler") }}</a-button
          >
        </div>
      </a-form>
    </a-drawer>
    <a-modal
      :visible="assignVisible"
      :title="$t('comptabilite.accountingClassAssign')"
      :confirm-loading="assignSaving"
      :width="420"
      @ok="onAssignOk"
      @cancel="closeAssignModal"
      destroy-on-close
    >
      <p>{{ $t("comptabilite.accountingClassAutoGeneratedHint") }}</p>
    </a-modal>

    <a-table
      :loading="tableLeading"
      :rowKey="'_id'"
      :columns="columns"
      :data-source="data"
      :pagination="true"
      :scroll="{ x: 'max-content' }"
    >
      <template slot="accountingClass" slot-scope="text, record">
        <a-tag v-if="record.accountingClass" color="geekblue">
          {{ record.accountingClass }}
        </a-tag>
        <template v-else>
          <a-button
            v-if="getServiceClass(record.service)"
            size="small"
            type="link"
            @click="openAssignModal(record)"
          >
            {{ $t("comptabilite.accountingClassAssign") }}
          </a-button>
          <a-tooltip v-else :title="$t('comptabilite.serviceClassMissing')">
            <a-icon
              type="warning"
              theme="filled"
              style="color: #faad14; font-size: 16px"
            />
          </a-tooltip>
        </template>
      </template>
      <template slot="service" slot-scope="text, record">
        <a-select
          show-search
          :disabled="!record.editable"
          :autoFocus="true"
          style="width: 100%"
          :placeholder="$t('recette.fournisseur')"
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="(e) => handleChange(e, record._id, 'service')"
          :default-value="record.service ? record.service : ''"
        >
          <a-select-option
            v-for="service in activeServicesData"
            :value="service._id"
            :key="service._id"
            >{{ service.name }}</a-select-option
          >
        </a-select>
      </template>

      <template
        v-for="col in ['designation', 'start', 'end', 'order', 'reponsible']"
        :slot="col"
        slot-scope="text, record"
      >
        <div v-if="!['end', 'start'].includes(col)" :key="`input-${col}`">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :type="
              col == ['inscription', 'monthly'].includes(col)
                ? 'number'
                : 'text'
            "
            :value="text"
            @change="(e) => handleChange(e.target.value, record._id, col)"
          />
          <template v-else>
            {{
              col == "monthly"
                ? !record.once
                  ? text
                  : $t("etablissement.seuleFois")
                : text
            }}
          </template>
        </div>
        <div v-else :key="`date-${col}`">
          <a-date-picker
            v-if="record.editable"
            :value="moment(text)"
            format="DD/MM/YYYY"
            @change="(v) => handleChange(v, record._id, col)"
          />
          <template v-else>
            <div v-if="text">{{ moment(text).format("DD/MM/YYYY") }}</div>
            <div v-else>--</div>
          </template>
        </div>
      </template>
      <template slot="tranches" slot-scope="text">
        <li v-for="t in text" :key="t.trancheNumber">
          {{ $t("etablissement.tranche") }} {{ t.trancheNumber }} :
          {{ t.amount }}
        </li>
      </template>
      <span slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
            <a-button type="primary" @click="() => showModal('edit', record)">
              <a-icon type="edit" />
              {{ $t("action.modifier") }}
            </a-button>
          </span>
        </div>
      </span>
      <span slot="operationSupprimer" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
            <a-button type="danger">
              <a-popconfirm
                :title="$t('requis.supp')"
                @confirm="() => supp(record._id)"
              >
                <a>{{ $t("action.supprimer") }}</a>
              </a-popconfirm>
            </a-button>
          </span>
        </div>
      </span>
    </a-table>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import moment from "moment";
import { mapState } from "vuex";
import { getRangeMonthsSY } from "@/utilities/settings";
import { showApiError } from "@/utilities/showApiError";

var activitiessData = [];
export default {
  name: "activities",
  computed: {
    ...mapState(["settings"]),
    columns() {
      return [
        {
          title: this.$t("etablissement.service"),
          dataIndex: "service",
          key: "service",
          scopedSlots: { customRender: "service" },
          sorter: (a, b) => a.service.length - b.service.length,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("comptabilite.accountingClass"),
          dataIndex: "accountingClass",
          key: "accountingClass",
          scopedSlots: { customRender: "accountingClass" },
        },
        {
          title: this.$t("etablissement.designation"),
          dataIndex: "designation",
          key: "designation",
          scopedSlots: { customRender: "designation" },
          sorter: (a, b) => a.designation.length - b.designation.length,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.fraisInscri"),
          dataIndex: "inscription",
          key: "inscription",
          scopedSlots: { customRender: "inscription" },
          sorter: (a, b) => a.inscription - b.inscription,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.fraisMensuel"),
          dataIndex: "monthly",
          key: "monthly",
          scopedSlots: { customRender: "monthly" },
          sorter: (a, b) => a.monthly - b.monthly,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.tranches"),
          dataIndex: "tranches",
          key: "tranches",
          scopedSlots: { customRender: "tranches" },
        },
        {
          title: this.$t("etablissement.responsable"),
          dataIndex: "reponsible",
          key: "reponsible",
          scopedSlots: { customRender: "reponsible" },
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.dateDebut"),
          dataIndex: "start",
          key: "start",
          scopedSlots: { customRender: "start" },
        },
        {
          title: this.$t("etablissement.dateFin"),
          dataIndex: "end",
          key: "end",
          scopedSlots: { customRender: "end" },
        },
        {
          title: this.$t("etablissement.order"),
          dataIndex: "order",
          key: "order",
          scopedSlots: { customRender: "order" },
          sorter: (a, b) => a.order.length - b.order.length,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("action.modifier"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
        {
          title: this.$t("action.supprimer"),
          dataIndex: "operationSupprimer",
          scopedSlots: { customRender: "operationSupprimer" },
          fixed: "right",
        },
      ];
    },
  },
  beforeMount() {
    this.form = this.$form.createForm(this, { name: "activityForm" });
    this.updateForm = this.$form.createForm(this, { name: "editActivityForm" });
  },
  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Activités",
    });
    this.monthRangesList = getRangeMonthsSY(
      this.settings.activeSchoolarYear,
      this.settings.schoolarYears
    );
    await apiClient
      .post("/services/filter", { query: {} })
      .then((res) => {
        this.services = res.data;
        this.activeServicesData = res.data.filter((e) => e.status == "active");
      })
      .catch((e) => {
        console.log(e);
        this.$message.error(this.$t("error.aucActivite"));
      });
    this.getActivities();
  },
  data() {
    return {
      tranchesList: [],
      monthRangesList: [],
      services: [],
      activeServicesData: [],
      once: true,
      tableLeading: true,
      visibleModal: false,
      visibleEditModal: false,
      form: this.$form.createForm(this),
      updateForm: this.$form.createForm(this),
      data: null,
      cacheData: null,
      loadingActivity: false,
      editingKey: "",
      selectedActivity: {},
      selectedTranches: [],
      activityType: "monthly",
      editActivityType: "monthly",
      assignVisible: false,
      assignSaving: false,
      assignTarget: null,
    };
  },
  methods: {
    endDateValidator(formName, rule, value, callback) {
      if (this.selectedActivity.once) {
        callback();
        return;
      }
      const start = this[formName].getFieldValue("start");
      const end = value;
      if (!start || !end) {
        callback();
        return;
      }
      if (!moment(end).isAfter(moment(start))) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    },
    async getActivities() {
      await apiClient
        .post("/activities/filter", {
          query: {
            status: "active",
          },
          aggregation: {
            $project: {
              __v: 0,
              updatedAt: 0,
              teachers: 0,
            },
          },
        })
        .then((res) => {
          activitiessData = [...res.data];
          activitiessData = activitiessData.map((elem) => {
            var sc = "";
            try {
              if (
                this.services.find((e) => e._id === elem.service).status ===
                "inactive"
              )
                elem.service = "--";
              sc = this.settings.schoolarYears.filter(
                (s) => s._id == elem.schoolarYear
              )[0]._id;
            } catch {
              sc = "";
            }
            return {
              ...elem,
              key: elem._id,
              schoolarYear: sc,
            };
          });
          this.data = activitiessData;
          this.cacheData = activitiessData.map((item) => ({ ...item }));
          this.tableLeading = false;
        })
        .catch((e) => this.$message.error(this.$t("error.aucActivite")));
    },
    addTranche() {
      this.selectedTranches.push({
        trancheNumber: this.selectedTranches.length + 1,
        amount: undefined,
        months: [],
      });
    },
    trigerOnce(v) {
      this.once = v;
    },
    handleActivityTypeChange(e) {
      this.activityType = e.target.value;
      if (this.activityType === "daily") {
        this.once = false;
      } else if (this.activityType === "monthly") {
        this.once = true; // Reset to default for monthly
      }
    },
    moment(any) {
      return moment(any);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    addActivity(e) {
      e.preventDefault();
      const thereEmpty = this.tranchesList.filter(
        (s) => !s.trancheNumber || !s.amount
      );

      if (thereEmpty.length > 0) {
        this.$message.warning(this.$t("etablissement.verifierTranches"));
        return;
      }
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.loadingActivity = true;
          values.tranches = this.tranchesList;

          let data = { ...values };
          data.once = this.once;
          data.daily = this.activityType === "daily";
          if (this.once && values.monthly) delete values.monthly;
          apiClient
            .put("/activities", { data: data })
            .then((res) => {
              this.$message.success(this.$t("success.activiteAjout"));
              const activitySchoolarYear =
                res.data.schoolarYear?._id || res.data.schoolarYear;
              if (
                activitySchoolarYear &&
                String(activitySchoolarYear) ===
                  String(this.settings.activeSchoolarYear)
              ) {
                res.data.key = res.data._id;
                let processedActivity = {
                  ...res.data,
                  key: res.data._id,
                  schoolarYear: String(activitySchoolarYear),
                };
                this.data.push(processedActivity);
                this.cacheData.push(processedActivity);
              }
              this.handleCancel();
            })
            .catch((e) =>
              this.$message.error(this.$t("error.impoAjoutActivites"))
            );
        } else {
          this.$message.warning(this.$t("warning.verifieDonnees"));
        }
        this.loadingActivity = false;
      });
    },
    showModal(type = "new", record = null) {
      this.updateForm.resetFields();
      this.form.resetFields();
      this.loadingActivity = false;
      if (type == "new") {
        this.activityType = "monthly"; // Reset to default
        this.once = true; // Reset to default
        this.visibleModal = true;
      } else {
        this.selectedActivity = { ...record };
        this.editActivityType = this.selectedActivity.daily
          ? "daily"
          : "monthly";
        // Ensure once is false for daily activities
        if (this.selectedActivity.daily) {
          this.selectedActivity.once = false;
        }
        if (!this.selectedActivity.tranches) this.selectedTranches = [];
        else this.selectedTranches = this.selectedActivity.tranches;
        this.visibleEditModal = true;
      }
    },
    handleCancel() {
      this.form.resetFields();
      this.visibleModal = false;
      this.visibleEditModal = false;
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    save(e) {
      e.preventDefault();
      this.updateForm.validateFieldsAndScroll((err, values) => {
        this.loadingActivity = true;
        if (!err) {
          const updates = {
            service: values.service,
            designation: values.designation,
            inscription: values.inscription,
            once: this.selectedActivity.once,
            daily: this.editActivityType === "daily",
            monthly: values.monthly,
            order: values.order,
            start: values.start,
            end: values.end,
            reponsible: values.reponsible,
            tranches: this.selectedTranches,
            schoolarYear: values.schoolarYear,
          };
          if (updates.once) {
            updates.end = null;
          }
          apiClient
            .patch("/activities/" + this.selectedActivity._id, {
              data: updates,
            })
            .then(() => {
              this.$message.success(this.$t("success.activiteMSA"));
              this.handleCancel();
              this.getActivities();
            })
            .catch((e) => {
              if (e.response.data.errorCode === "ACTIVITY_HAS_PAYMENTS") {
                this.$message.error(this.$t("error.activiteHasPayments"));
              } else {
                this.$message.error(this.$t("error.activiteNonMSA"));
              }
            });
        } else {
          this.$message.warning(this.$t("warning.verifieDonnees"));
        }
        this.loadingActivity = false;
      });
    },

    supp(key) {
      apiClient
        .patch("/activities/" + key, { data: { status: "inactive" } })
        .then(() => {
          this.$message.success(this.$t("success.activiteSupp"));
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item.key !== key);
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(this.$t("error.activiteNonSupp"));
        });
    },
    getServiceClass(serviceId) {
      if (!serviceId) return "";
      const svc = this.activeServicesData.find(
        (s) => String(s._id) === String(serviceId)
      );
      return (svc && svc.accountingClass) || "";
    },
    openAssignModal(record) {
      this.assignTarget = record;
      this.assignVisible = true;
    },
    closeAssignModal() {
      this.assignVisible = false;
      this.assignTarget = null;
    },
    onAssignOk() {
      if (!this.assignTarget) return;
      this.assignSaving = true;
      apiClient
        .patch(`/activities/${this.assignTarget._id}/assign-class`, {
          data: {},
        })
        .then((res) => {
          this.$message.success(this.$t("success.operationEffectue"));
          const idx = this.data.findIndex(
            (r) => r._id === this.assignTarget._id
          );
          if (idx !== -1) {
            this.$set(this.data, idx, {
              ...this.data[idx],
              accountingClass: res.data.accountingClass,
              accountingParentClass: res.data.accountingParentClass,
            });
          }
          this.closeAssignModal();
        })
        .catch((e) => showApiError(this, e))
        .finally(() => {
          this.assignSaving = false;
        });
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
